import mod from "-!./peoplePage.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./peoplePage.js?vue&type=script&lang=js&external"